import classNames from "classnames";
import { useSearchDispatch, useSearchStoreContext } from "PFApp/search/search_context";
import { Icon } from "PFComponents/icon";
import { LoadingDots } from "PFComponents/loading_dots";
import { SEARCH_ACTIONS } from "PFReducers/search_reducer/search_reducer";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router";

import css from "./recent_searches.module.scss";

const RecentSearches = ({ searches, isLoading }) => {
  const navigate = useNavigate();
  const dispatch = useSearchDispatch();
  const {
    search: { choosenKeywords }
  } = useSearchStoreContext();
  const { t } = useTranslation("search");

  const resetState = (path, payload) => {
    dispatch({ type: SEARCH_ACTIONS.SEARCH_RESET_STATE, payload });
    navigate(path, { replace: true });
  };

  return (
    <div className={classNames(css.root, { [css.isSeparated]: choosenKeywords.length > 0 })}>
      <h1>
        <Icon name="search" size="lg" />
        <span>{t("parts.recentSearches")}</span>
      </h1>

      {isLoading ? (
        <LoadingDots circlesEnabled pageViewEnabled />
      ) : (
        <>
          {searches && searches.length === 0 && <div>{t("parts.noPastSearches")}</div>}

          {searches && searches.length > 0 && (
            <ul className={css.list}>
              {searches.map(({ activity }) => (
                <RecentSearch task={activity} resetState={resetState} key={activity.id} />
              ))}
            </ul>
          )}
        </>
      )}
    </div>
  );
};

RecentSearches.propTypes = {
  searches: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.number, description: PropTypes.string })),
  isLoading: PropTypes.bool
};

const RecentSearch = ({ task, resetState }) => {
  const { t } = useTranslation("search");

  const term = task.description || t("parts.noSearchName");
  const encodedTerm = window.encodeURI(term).replace(/\//g, "%2f");
  const path = `/search/${task.id}/all/${encodedTerm}`;

  const onClick = (e) => {
    e.preventDefault();
    resetState(path, { autoselectEnabled: false });
  };

  return (
    <li>
      <Link to={path} onClick={onClick} className={css.link}>
        <Icon name="caret-down" size="lg" />
        {term}
      </Link>
    </li>
  );
};

RecentSearch.propTypes = {
  task: PropTypes.shape({ description: PropTypes.string, id: PropTypes.number }).isRequired,
  resetState: PropTypes.func.isRequired
};

export default RecentSearches;
